import { render, staticRenderFns } from "./RecaudacionIndex.vue?vue&type=template&id=6dfffff8&scoped=true"
import script from "./RecaudacionIndex.vue?vue&type=script&lang=ts"
export * from "./RecaudacionIndex.vue?vue&type=script&lang=ts"
import style0 from "./RecaudacionIndex.vue?vue&type=style&index=0&id=6dfffff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfffff8",
  null
  
)

export default component.exports